import React from 'react';
import Root from '../../components/root';

const RootContainer = () => <Root />;

export default RootContainer;
